import FreeTextSearch from "@grindex-client/components/Search/Pages/free-text-search.class";
import EventManager from "@grindex-common/helpers/EventManager.class";

function init($views) {
	const tabs: FreeTextSearch[] = [];
	var index = 1;
	$views.forEach(($module) => {
		const eventManager = new EventManager();
		const search = new FreeTextSearch($module, eventManager);

		search.searchIndex = index;

		index++;

		tabs.push(search);
	});

	tabs.forEach((tabInstance) => {
		tabInstance.siblingTabs = tabs.filter((tab) => {
			return tab.tab !== tabInstance.tab;
		});
	});

	tabs.forEach((tabInstance) => {
		tabInstance.search(false);
	});
}

export default {
	view: "free-text-searchPage",
	init,
};
